import {getLinkProps} from '~/cms/components/LinkComponent'
import {SingleLineStructuredText} from '~/cms/components/SingleLineStructuredText'
import {
  type HgEmailCaptureProps,
  type HgEmailCaptureVariant,
} from '~/design-system/hg/components'
import {unreachableCase} from '~/design-system/utils'
import {type NewsletterList} from '~/mercuryWebBackend/endpoints/NewsletterSubscribe'
import {getEmailCaptureProps} from '.'
import {type EmailCaptureFragment} from './_generated/fragments.graphql'

export function getEmailCaptureDestinationProps(
  data: EmailCaptureFragment & {organizationName?: string}
): HgEmailCaptureProps {
  const {
    labelText,
    destination,
    submitButtonText,
    variant,
    secondaryLink,
    organizationName,
  } = data

  const destinationProps = (() => {
    switch (destination.__typename) {
      case 'EmailCaptureComponentSignupDestinationRecord':
        return getEmailCaptureProps({
          destination: 'signup',
          signupUrl: (
            destination.signupUrl || 'https://app.mercury.com/redirect/autofill'
          ).trim(),
        })
      case 'EmailCaptureComponentSubscribeDestinationRecord':
        return getEmailCaptureProps({
          destination: 'subscribe',
          list: destination.newsletterList as NewsletterList,
        })
      default:
        return unreachableCase(destination)
    }
  })()

  return {
    submitButtonText,
    successMessage: destination.__typename ===
      'EmailCaptureComponentSubscribeDestinationRecord' && (
      <SingleLineStructuredText data={destination.successMessage} />
    ),
    labelText,
    variant: variant as HgEmailCaptureVariant,
    secondaryLinkProps: getLinkProps(secondaryLink),
    organizationName:
      destination.__typename === 'EmailCaptureComponentSignupDestinationRecord'
        ? organizationName
        : undefined,
    ...destinationProps,
  }
}
